import { render, staticRenderFns } from "./FormClosingClaimCourier.vue?vue&type=template&id=6bcf0ae5&scoped=true"
import script from "./FormClosingClaimCourier.vue?vue&type=script&lang=js"
export * from "./FormClosingClaimCourier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf0ae5",
  null
  
)

export default component.exports